<template>
  <div class="hero">
    <div class="hero-overlay">
      <div class="hero-content">
        <div class="hero-header">
          <Navigation></Navigation>
        </div>

        <div class="hero-content-inner">
          <img class="hero-logo-img mr-auto" @click="refresh" src="../assets/regtime_logo.svg" alt="">

          <div class="hero-title">485x/UAP Matching Tool</div>
          <div class="hero-subtitle">Let's begin</div>

          <SearchComponent :order="'page top search'"></SearchComponent>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchComponent from '@/components/SearchComponent.vue';
import Navigation from "@/components/Navigation";

export default {
  name: 'Hero',
  components: {
    SearchComponent,
    Navigation,
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    }
  }
}
</script>

<style lang="scss">
@import "../scss/variables.scss";

.hero {
  width: 100vw;
}

.hero-overlay {
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(0deg, rgba(44, 35, 53, 0.50) 0%, rgba(44, 35, 53, 0.50) 100%), url("../assets/herobkg.png") no-repeat center center;
  background-size: cover;
  }

.hero-header {
  position: relative;
  top: 0;
  width: 100vw;
}

.hero-content {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;

  position: absolute;
}

.hero-content-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;

  margin-top: 80px;
}

.hero-logo-img {
  width: 307px;
  height: 80px;
  margin: 0 auto; // добавлено для горизонтального центрирования
  cursor: pointer;
}

.hero-title {
  color: #FFF;
  text-align: center;
  font-family: "Open Sans";
  font-size: 64px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  /* 80px */
  margin-top: 48px;
}

.hero-subtitle {
  color: #FFF;
  text-align: center;
  font-family: "Open Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 48px */
  margin-top: 8px;
  margin-bottom: 68px;
}

</style>
